module.exports = __webpack_public_path__ + "static/media/03C.d5438a43.png";